import React  from 'react';
import './Topbar.css';
import { FiMenu } from "react-icons/fi"
import Navbar from "../Navbar"
import TopbarPopupMenu from "./TopbarPopupMenu.js"

import { AiOutlineCamera } from "react-icons/ai"
import { BsPersonCircle, BsChat } from "react-icons/bs"
import { HiOutlineCog } from "react-icons/hi"
import { MdOutlineDesignServices, MdAlternateEmail } from "react-icons/md"
import { MdGraphicEq } from "react-icons/md"

class Topbar extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			showPopupMenuYN: false,
			popupMenuClosedByCircleYN: true,
		}

		this.handleNavbarToggle = this.handleNavbarToggle.bind(this);
		this.closeNavbar = this.closeNavbar.bind(this);
		this.handlePopupMenuToggle = this.handlePopupMenuToggle.bind(this);
		this.closePopupMenu = this.closePopupMenu.bind(this);
		this.renderLogo = this.renderLogo.bind(this);		
	}

	handleNavbarToggle() {
		var navbarOpenYN = this.props.navbarOpenYN;
		navbarOpenYN = !navbarOpenYN;
		this.props.setNavbarOpenYN(navbarOpenYN);
	}

	closeNavbar() {
		this.props.setNavbarOpenYN(false);
	}

	handlePopupMenuToggle() {

		var showPopupMenuYN = this.state.showPopupMenuYN;
		var popupMenuClosedByCircleYN = this.state.popupMenuClosedByCircleYN;
		
		if (!popupMenuClosedByCircleYN) {
			showPopupMenuYN = true;
		}

		showPopupMenuYN = !showPopupMenuYN;

		this.setState({
			popupMenuClosedByCircleYN: true,
			showPopupMenuYN: showPopupMenuYN,
		});
	}
	
	closePopupMenu() {
		this.setState({
			popupMenuClosedByCircleYN: false,
			showPopupMenuYN: false,
		});
	}
	
	renderLogo(iconName) {
		
		if (iconName === "CHAT") {
			return (<BsChat style={{ padding: "5px", color: "white", width: "40px", height: "40px" }} />);
		}

		if (iconName === "APPS") {
			return (<BsPersonCircle style={{ color: "white", width: "50px", height: "50px" }} />);
		}

		if (iconName === "PRODUCTION") {
			return (<HiOutlineCog style={{ color: "white", width: "50px", height: "50px" }} />);
		}
		
		if (iconName === "DEVEL") {
			return (<MdOutlineDesignServices style={{ color: "white", width: "50px", height: "50px" }} />);
		}
		
		if (iconName === "AI") {
			return (<MdGraphicEq style={{ color: "white", width: "50px", height: "50px" }} />);
		}
		
		if (iconName === "REPLY") {
			return (<MdAlternateEmail style={{ color: "white", width: "50px", height: "50px" }} />);
		}

		if (iconName === "GUARDS") {
			return (<AiOutlineCamera style={{ color: "white", width: "50px", height: "50px" }} />);
		}

		return null;
	}
	
	render() {

		var userID = this.props.userID;
		var email = this.props.email;
		var firstName = this.props.firstName;
		var lastName = this.props.lastName;
		var navbarOpenYN = this.props.navbarOpenYN;
		
		var showNavBarYN = true;
		if (userID === 0) {
			showNavBarYN = false;
		}
		
		var initialLetters = "";
		
		if (firstName !== "") {
			initialLetters = firstName.substring(0, 1);
		}
		
		if (lastName !== "") {
			initialLetters = initialLetters + lastName.substring(0, 1);
		}
		
		if (initialLetters === "") {
			initialLetters = email.substring(0, 1);
		}
		
		var iconName = this.props.iconName;
		var appName = this.props.appName;
		
		if (iconName === "") {
			iconName = appName;
		}
		
		return (
			<div className="TopbarContainer" style={{backgroundColor: this.props.bkColor1}}>
				{this.state.showPopupMenuYN && (
					<TopbarPopupMenu
						managementBaseURLAPI={this.props.managementBaseURLAPI}
						dbtouch={this.props.dbtouch}
						userID={this.props.userID}
						email={this.props.email}
						sessionID={this.props.sessionID}
						logoutClearVariables={this.props.logoutClearVariables}
						closePopupMenu={this.closePopupMenu}
						getLang={this.props.getLang}
						setLanguage={this.props.setLanguage}
					/>
				)}
				<div className="TopbarLeft">
					<div className="TopbarLeftColumn1">
						{showNavBarYN && (
							<button id="fimenu" onClick={this.handleNavbarToggle}>
								<FiMenu style={{ color: "#7b7b7b", width: "30px", height: "30px" }} />
							</button>
						)}
						<Navbar
							navbarOpenYN={navbarOpenYN}
							appUserType={this.props.appUserType}
							modelLearnYN={this.props.modelLearnYN}
							closeNavbar={this.closeNavbar}
							setSnapshotListIndex={this.props.setSnapshotListIndex}
							logoutClearVariables={this.props.logoutClearVariables}
							getLang={this.props.getLang}
							modelUserType={this.props.modelUserType}
						/>
					</div>
					<div className="TopbarLeftColumn2">
						<div className="TopbarLogo1">
							{this.renderLogo(iconName)}
						</div>
					</div>
					<div className="TopbarLeftColumn3">
						<div className="TopbarLogo2">AI CHATBOT</div>
						{/*<div className="TopbarLogo3">{appName}</div>*/}
					</div>
				</div>
				{showNavBarYN && (
					<div className="TopbarRight" onClick={this.handlePopupMenuToggle}>
						<div className="TopbarInitialsContainer">
							<span className="TopbarInitials">{initialLetters}</span>
						</div>
					</div>
				)}
				{!showNavBarYN && (
					<div className="TopbarRight2">
					</div>
				)}
			</div>
		);
	}
}

export default Topbar;

